import logo from './logo.svg';
import './App.css';
import Qoute from './qoute.js';
function App() {
  return (
    <div className="App">  
      <Qoute/>  
    </div>
  );
}

export default App;
